import { memo, type FC, type ReactNode } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

type EmptyStateProps = {
  icon?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  minHeight?: number;
};

export const EmptyState: FC<EmptyStateProps> = memo(
  ({ icon, title, subtitle, minHeight = 300 }) => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight,
          width: "100%",
          color: "text.secondary",
          textAlign: "center",
        }}
      >
        {icon}
        <Typography variant="body2">{title}</Typography>
        {subtitle && (
          <Typography variant="caption" sx={{ mt: 1 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
    );
  }
);

EmptyState.displayName = "EmptyState";
